// extracted by mini-css-extract-plugin
module.exports = {"container":"Expiration_container__10FVX"};